var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconinfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 33,
    viewBox: "0 0 20 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 6.70703,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F79009"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5222 19.2479L10.532 19.2391L10.5408 19.2293C10.599 19.1646 10.6531 19.0899 10.6921 18.99C10.727 18.9052 10.75 18.8087 10.75 18.707C10.75 18.6041 10.7264 18.5064 10.6908 18.4209C10.6545 18.3339 10.604 18.255 10.5408 18.1848L10.532 18.175L10.5222 18.1662C10.452 18.103 10.3731 18.0525 10.2862 18.0163C10.1046 17.9406 9.89538 17.9406 9.71385 18.0163C9.62688 18.0525 9.54801 18.103 9.47776 18.1662L9.46798 18.175L9.45918 18.1848C9.39596 18.255 9.34547 18.3339 9.30923 18.4209C9.27358 18.5064 9.25 18.6041 9.25 18.707C9.25 18.8087 9.273 18.9052 9.30792 18.99C9.34687 19.0899 9.40099 19.1646 9.45918 19.2293L9.46798 19.2391L9.47776 19.2479C9.548 19.3111 9.62688 19.3616 9.71385 19.3978C9.79942 19.4335 9.89707 19.457 10 19.457C10.1029 19.457 10.2006 19.4335 10.2862 19.3978C10.3731 19.3616 10.452 19.3111 10.5222 19.2479ZM5.25 16.707C5.25 14.0901 7.38307 11.957 10 11.957C12.6169 11.957 14.75 14.0901 14.75 16.707C14.75 19.324 12.6169 21.457 10 21.457C7.38307 21.457 5.25 19.324 5.25 16.707ZM10 14.082C9.65693 14.082 9.375 14.364 9.375 14.707V17.207C9.375 17.5501 9.65693 17.832 10 17.832C10.3431 17.832 10.625 17.5501 10.625 17.207V14.707C10.625 14.364 10.3431 14.082 10 14.082Z",
    fill: "#FFFCF5",
    stroke: "#FFFCF5",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconinfo);
export default __webpack_public_path__ + "static/media/iconinfo.193190b02ef50a539abbf3d6b6d2af8d.svg";
export { ForwardRef as ReactComponent };